import { SearchOutlined } from '@ant-design/icons'
import { Card, Flex, Input, Select } from 'antd'
import { PropertyActivityPtoType } from 'Modules'

import { PROPERTY_ACTIVITY_PTO_TYPE_FILTER_OPTIONS } from 'constants/property-activities'

interface PtoListFilterProps {
  searchText: string
  onSearchChange: (value: string) => void
  type: PropertyActivityPtoType | 'ALL'
  onTypeChange: (value: PropertyActivityPtoType | 'ALL') => void
}

export const PtoListFilter = ({
  searchText,
  onSearchChange,
  type,
  onTypeChange,
}: PtoListFilterProps) => {
  return (
    <Card className="property-activities__filter-card" styles={{ body: { padding: 16 } }}>
      <Flex gap={16} align="center">
        <Input
          placeholder="Search PTOs..."
          prefix={<SearchOutlined style={{ color: '#9ca3af' }} />}
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          allowClear
          style={{ flex: 1 }}
        />
        <Select
          value={type}
          onChange={onTypeChange}
          options={PROPERTY_ACTIVITY_PTO_TYPE_FILTER_OPTIONS}
          style={{ width: 200 }}
        />
      </Flex>
    </Card>
  )
}
